import { ModuleConfig, ModuleRegistry } from './types';
export type { ModuleConfig, MenuConfig, LocalizedString, ModuleRegistry } from './types';

function assertLabel(label: { en?: string; af?: string }, context: string): void {
  if (!label?.en) throw new Error(`${context}: missing en label`);
  if (!label?.af) throw new Error(`${context}: missing af label`);
}

export function validateRegistry(configs: ModuleConfig[]): ModuleRegistry {
  const out: Record<string, ModuleConfig> = {};
  for (const cfg of configs) {
    if (out[cfg.key]) throw new Error(`duplicate module key: ${cfg.key}`);
    assertLabel(cfg.label, `module '${cfg.key}'`);
    if (!cfg.icon) throw new Error(`module '${cfg.key}': missing icon`);
    if (!Array.isArray(cfg.menus) || cfg.menus.length === 0) {
      throw new Error(`module '${cfg.key}': must have at least one menu`);
    }
    const menuKeys = new Set<string>();
    for (const menu of cfg.menus) {
      if (menuKeys.has(menu.key)) {
        throw new Error(`duplicate menu key: ${cfg.key}:${menu.key}`);
      }
      menuKeys.add(menu.key);
      assertLabel(menu.label, `menu '${cfg.key}:${menu.key}'`);
      if (!menu.path || !menu.path.startsWith('/')) {
        throw new Error(`menu '${cfg.key}:${menu.key}': path must start with /`);
      }
    }
    out[cfg.key] = cfg;
  }
  return Object.freeze(out);
}
